import { render } from "./AttachmentModal.vue?vue&type=template&id=789aeda2&scoped=true"
import script from "./AttachmentModal.vue?vue&type=script&lang=js"
export * from "./AttachmentModal.vue?vue&type=script&lang=js"

import "./AttachmentModal.vue?vue&type=style&index=0&id=789aeda2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789aeda2"]])

export default __exports__